$.validator.setDefaults({
    ignore: ".ignore"
});